import React, { useEffect, useState } from "react";
import {
  View,
  ScrollView,
  TouchableHighlight,
  StyleSheet,
  Platform,
} from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";
import * as Actions from "../actions/SmartParkingActions";
import Theme from "../argon-ui/Theme";
import SmartParking, {
  ParkingArea,
  ParkingLot,
} from "../viewModels/SmartParking";
import { IconButton } from "../components_v2/Buttons";
import { translate } from "../locales/translate";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import * as faCharCodes from "../../assets/consts/faCharCodes";
import Loading from "../components/Loading";
import { ParkingLotItem } from "./ParkingLotListScreen";
import useSortList from "../hooks/useSortList";
import { NavigationScreenComponent } from "react-navigation";
interface props {
  name: string;
  smartParking: SmartParking;
  smartParkingId: string;
  parkingAreas: ParkingArea[];
  navigation: any;
  singleSmartParking: boolean;
  ScenarioReducer: object[];
  updateAction: any;
  accessToken: string;
}

const ParkingListScreen = (props: any) => {
  const [parkings, setParking] = useState<SmartParking[]>(
    props.AreaReducer.parkings
  );

  const [accessToken, setAccessToken] = useState<string>("");
  useEffect(() => {
    setParking(props.AreaReducer.parkings);

    // console.log('props.AreaReducer.parkings.length', props.AreaReducer.parkings.length)
    setAccessToken(props.appReducer?.currentServer.accessToken);
  }, [props.AreaReducer.parkings, props.appReducer]);

  return (
    <View
      style={{
        flex: 1,
        paddingHorizontal: 10,
        marginVertical: 5,
        borderRadius: 5,
      }}
    >
      {!props.AreaReducer.parkingsLoaded ? (
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loading />
        </View>
      ) : parkings.length == 0 ? (
        <View
          style={{ flex: 1, justifyContent: "center", alignContent: "center" }}
        >
          <Text
            style={{ fontSize: 15, fontWeight: "bold", textAlign: "center" }}
          >
            {translate("app.emptyList")}
          </Text>
        </View>
      ) : (
        <ScrollView style={{ marginTop: 5 }}>
          {parkings.map((item: SmartParking | any) => {
            return (
              <ParkingListItem
                accessToken={accessToken}
                updateAction={props.update}
                key={item.id}
                smartParking={item}
                smartParkingId={item.id}
                ScenarioReducer={props.ScenarioReducer}
                name={item.name}
                parkingAreas={item.parkingAreas}
                navigation={props.navigation}
                singleSmartParking={
                  props.AreaReducer.parkings.length == 1 ||
                  props.AreaReducer.parkings.length == 0
                    ? true
                    : false
                }
              />
            );
          })}
        </ScrollView>
      )}
      {/* === Add & reserveList Btn=== */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-around",
          // padding: 10,
          marginBottom: 5,
          // backgroundColor: Theme.COLORS.WHITE,
        }}
      >
        <TouchableHighlight
          style={[styles.btn, { width: "100%" }]}
          underlayColor={Theme.COLORS.THIRED}
          onPress={() => {
            props.navigation.navigate("SmartParkingForm");
          }}
        >
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <FontAwesomeIcon icon={faCharCodes.faPlus} size={16} color="#FFF" />
            <Text style={{ color: Theme.COLORS.WHITE, marginHorizontal: 8 }}>
              {translate("smartParking.addParkingLot")}
            </Text>
          </View>
        </TouchableHighlight>
      </View>
    </View>
  );
};
const ParkingListItem: React.FC<props> = ({
  name,
  smartParking,
  smartParkingId,
  parkingAreas,
  navigation,
  singleSmartParking: singleSmartParking,
  ScenarioReducer,
  updateAction,
  accessToken,
}: props) => {
  // === SmartParking ===
  const [smartParkingList, setSmartParking] =
    useState<SmartParking>(smartParking);
  // === Area Parkings ===
  const [parkingAreasList, setParkingAreasList] = useState<ParkingArea[]>(
    smartParking.parkingAreas
  );
  // === Parking Lots ===

  const [openDropDown, setOpenDropDown] = useState<boolean>(singleSmartParking);
  const updateParkingAreasHandler = (parkingLots: ParkingLot[]) => {
    const _parkingArea = [...parkingAreas];
    for (let item in _parkingArea) {
      if (_parkingArea[item].id === parkingLots[0].parkingAreaId) {
        _parkingArea[item].parkingLots = parkingLots;
      }
    }
  };
  const updateSmartParkingHandler = (smartParking: SmartParking) => {
    updateAction(smartParking, accessToken);
    setShowBtnChange(false);
  };
  const [showBtnChange, setShowBtnChange] = useState(false);
  return (
    <View
      style={{
        borderRadius: 5,
        backgroundColor: Theme.COLORS.WHITE,
        shadowColor: Theme.COLORS.MUTED,
        marginBottom: 10,
        shadowOffset: {
          width: 0,
          height: 3,
        },
        shadowOpacity: 0.2,
        shadowRadius: 6.65,
        elevation: 4,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <TouchableHighlight
          underlayColor={Theme.COLORS.LIGHT_MAIN}
          style={[
            {
              paddingLeft: 10,
              paddingVertical: 20,
              width: "80%",
            },
            Platform.OS == "web" && { paddingRight: 10 },
          ]}
          onPress={() => singleSmartParking && setOpenDropDown(!openDropDown)}
        >
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <View style={{}}>
              <Text
                style={{ fontSize: 16, marginBottom: 8, fontWeight: "bold" }}
              >
                {name}
              </Text>
              <Text style={{ fontSize: 16 }}>
                {translate("smartParking.numberOfFloors")} :{" "}
                {parkingAreas.length}
              </Text>
            </View>

            <IconButton
              style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                justifyContent: "center",
                alignItems: "center",
              }}
              onPress={() => setOpenDropDown(!openDropDown)}
              icon={{
                code: !openDropDown ? "\uf0d7" : "\uf0d8",
                style: {
                  fontFamily: "FontAwesomeProLight",
                  fontSize: 20,

                  // color: Theme.COLORS.WHITE,
                },
              }}
            />
          </View>
        </TouchableHighlight>
        <IconButton
          style={{
            width: "20%",
            height: 40,
            borderRadius: 20,
            justifyContent: "center",
            alignItems: "center",
          }}
          onPress={() => {
            navigation.navigate("SmartParkingForm", {
              smartParkingId: smartParkingId,
            });
          }}
          icon={{
            code: "\uf044",
            style: {
              fontFamily: "FontAwesomeProLight",
              fontSize: 20,

              // color: Theme.COLORS.WHITE,
            },
          }}
        />
      </View>
      {showBtnChange && (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-around",
            marginBottom: 10,
          }}
        >
          <TouchableHighlight
            style={[
              styles.btn,
              {
                backgroundColor: Theme.COLORS.MUTED,
                shadowColor: Theme.COLORS.MUTED,
              },
            ]}
            underlayColor={Theme.COLORS.THIRED}
            onPress={() => {
              // props.navigation.navigate("SmartParkingForm");
            }}
          >
            <View>
              <Text style={{ color: Theme.COLORS.WHITE, marginHorizontal: 8 }}>
                {translate("app.cancel")}
              </Text>
            </View>
          </TouchableHighlight>
          <TouchableHighlight
            style={[styles.btn]}
            underlayColor={Theme.COLORS.THIRED}
            onPress={() => {
              updateSmartParkingHandler(smartParkingList);
            }}
          >
            <View>
              <Text style={{ color: Theme.COLORS.WHITE, marginHorizontal: 8 }}>
                {translate("app.applyChanges")}
              </Text>
            </View>
          </TouchableHighlight>
        </View>
      )}
      {openDropDown && (
        <View>
          <View style={{ borderRadius: 5, paddingHorizontal: 8 }}>
            {parkingAreasList.map((item: ParkingArea) => {
              return (
                <RenderParkingArea
                  key={item.id}
                  setParkingAreasList={setParkingAreasList}
                  parkingAreasList={parkingAreasList}
                  parkingArea={item}
                  ScenarioReducer={ScenarioReducer}
                  navigation={navigation}
                  setShowBtnChange={setShowBtnChange}
                  updateParkingAreas={(parkingLots: ParkingLot[]) =>
                    updateParkingAreasHandler(parkingLots)
                  }
                />
              );
            })}
          </View>
        </View>
      )}
    </View>
  );
};
const RenderParkingArea = (props: any) => {
  const {
    parkingArea,
    ScenarioReducer,
    navigation,
    setShowBtnChange,
    updateParkingAreas,
    parkingAreasList,
  } = props;
  useEffect(() => {
    setParkingLots(parkingArea.parkingLots);
  }, [parkingArea.parkingLots]);
  const [showParkingLot, setShowParkingLot] = useState(false);
  const [parkingLots, setParkingLots] = useState<ParkingLot[] | []>(
    useSortList(parkingArea.parkingLots, "name")
  );
  return (
    <View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 10,
          maxHeight: 85,
        }}
      >
        <TouchableHighlight
          style={{
            shadowColor: Theme.COLORS.MUTED,
            width: "80%",
            height: 80,
            justifyContent: "center",

            shadowOffset: {
              width: 0,
              height: 3,
            },
            shadowOpacity: 0.2,
            shadowRadius: 6.65,
            elevation: 4,
            paddingHorizontal: 10,
            paddingVertical: 15,
            borderRadius: 5,
            backgroundColor: Theme.COLORS.PRIMARY,
          }}
          onPress={() => {
            setShowParkingLot(!showParkingLot);
            // navigation.navigate("ParkingLotsListScreen", {
            //   parkingLots: item.parkingLots,
            // });
          }}
          underlayColor={Theme.COLORS.THIRED}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {/* === Toggle ParkingLot DropDown === */}
              <IconButton
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 20,
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onPress={() => {
                  setShowParkingLot(!showParkingLot);
                }}
                icon={{
                  code: showParkingLot ? "\uf148" : "\uf03a",
                  style: {
                    fontFamily: "FontAwesomeProLight",
                    fontSize: 20,
                    color: Theme.COLORS.WHITE,
                  },
                }}
              />

              <Text
                style={{
                  color: Theme.COLORS.WHITE,
                  // fontWeight: "bold",
                  fontSize: 15,
                }}
              >
                {parkingArea.name}
              </Text>
            </View>
            {/* === btn move to reserved list=== */}
            <TouchableHighlight
              underlayColor={Theme.COLORS.THIRED}
              onPress={() => {
                props.navigation.navigate("ParkingReservationList", {
                  smartParkingId: parkingArea.smartParkingId,
                  parkingAreaId: parkingArea.id,
                });
              }}
            >
              <View style={{ justifyContent: "center", alignItems: "center" }}>
                <IconButton
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 20,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={() => {
                    props.navigation.navigate("ParkingReservationList", {
                      smartParkingId: parkingArea.smartParkingId,
                      parkingAreaId: parkingArea.id,
                    });
                  }}
                  icon={{
                    code: "\uf1da",
                    style: {
                      fontFamily: "FontAwesomeProLight",
                      fontSize: 20,
                      color: Theme.COLORS.WHITE,
                    },
                  }}
                />
                <Text style={{ color: Theme.COLORS.WHITE, fontSize: 14 }}>
                  {translate("smartParking.reservation.reservationList")}
                </Text>
              </View>
            </TouchableHighlight>
          </View>
        </TouchableHighlight>
        <TouchableHighlight
          onPress={() =>
            navigation.navigate("ParkingResevetionForm", {
              parkingArea: parkingArea,
              // parkingAreasList:parkingAreasList
            })
          }
          underlayColor={Theme.COLORS.LIGHT_MAIN}
          style={{
            width: "18%",
            height: 80,
            borderRadius: 5,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              backgroundColor: Theme.COLORS.LIGHT_MAIN,
              borderRadius: 5,
              height: 80,
            }}
          >
            <FontAwesomeIcon
              icon={faCharCodes.faPlus}
              size={20}
              color={Theme.COLORS.PRIMARY}
            />

            <Text style={{ fontWeight: "bold", marginTop: 8 }}>
              {translate("smartParking.reserveParking")}
            </Text>
          </View>
        </TouchableHighlight>
      </View>
      <RenderParkingLot
        parkingLots={parkingLots}
        setParkingLots={setParkingLots}
        scenarioReducer={ScenarioReducer}
        showParkingLot={showParkingLot}
        setShowBtnChange={setShowBtnChange}
        updateParkingAreas={(parkingLots: ParkingLot[]) =>
          updateParkingAreas(parkingLots)
        }
      />
    </View>
  );
};

const RenderParkingLot = (props: any) => {
  const {
    showParkingLot,
    parkingLots,
    scenarioReducer,
    setShowBtnChange,
    setParkingLots,
    updateParkingAreas,
  } = props;
  const updateParkingLotHandler = (dataParkingLot: ParkingLot) => {
    for (let item in parkingLots) {
      if (parkingLots[item].id === dataParkingLot.id) {
        // === Compare last ParkingLot between new Data ===
        const matches = (obj: any, source: any) =>
          Object.keys(source).every(
            (key) => obj.hasOwnProperty(key) && obj[key] === source[key]
          );
        if (matches(parkingLots[item], dataParkingLot)) {
          return true;
        }
        var _parkingLots = [...parkingLots];
        _parkingLots[Number(item)] = dataParkingLot;
        setParkingLots(_parkingLots);
        setShowBtnChange(true);
        updateParkingAreas(_parkingLots);
      }
    }
  };
  return (
    showParkingLot && (
      <View>
        <ScrollView style={{ padding: 5 }}>
          {parkingLots.length == 0 ? (
            <Text style={{ textAlign: "center", marginVertical: 5 }}>
              {translate("app.emptyList")}
            </Text>
          ) : (
            parkingLots?.map((item: any) => {
              return (
                <ParkingLotItem
                  scenarioReducer={scenarioReducer}
                  item={item}
                  key={item.id}
                  updateParkingLot={(updateData: ParkingLot) => {
                    updateParkingLotHandler(updateData);
                  }}
                />
              );
            })
          )}
        </ScrollView>
      </View>
    )
  );
};

const styles = StyleSheet.create({
  btnAdd: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: Theme.COLORS.PRIMARY,
    //position: "absolute",
    marginHorizontal: 15,
    bottom: 15,
    shadowColor: Theme.COLORS.PRIMARY,
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  btn: {
    minWidth: 160,
    borderRadius: 5,
    shadowRadius: 5,
    paddingHorizontal: 15,
    paddingVertical: 10,
    backgroundColor: Theme.COLORS.PRIMARY,
    alignItems: "center",
    justifyContent: "center",

    shadowColor: Theme.COLORS.PRIMARY,
    shadowOffset: {
      width: 0,
      height: 3,
    },
    shadowOpacity: 0.3,
    elevation: 9,
  },
});
const mapStateToProps = (state: any) => {
  return {
    ScenarioReducer: state.ScenarioReducer,
    AreaReducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    add: (model: SmartParking, accessToken: string) => {
      dispatch(Actions.Add(model, accessToken));
    },
    update: (model: SmartParking, accessToken: string) => {
      dispatch(Actions.Update(model, accessToken));
    },
  };
};

ParkingListScreen["navigationOptions"] = ({
  screenProps: { translate },
}: any) => ({
  headerTitle: translate("navigation.Parkings"),
});
export default connect(mapStateToProps, mapDispatchToProps)(ParkingListScreen);
